<template>
  <ToggleSection label="Vitrification (Cryo TEM)" :collapsed="!dv.isEditing">
    <FieldGrid
      class="form-fields"
      :fields="[
        ['vitrification_instrument'],
        ['temperature', 'humidity'],
        ['blot_paper_type', 'cryogen'],
        ['sample_volume', 'fiducials_used'],
        ['wait_time', 'blot_time'],
        ['blot_force', 'blot_side'],
      ]"
      :dv="dv"
      :validation-errors="validationErrors"
    />
  </ToggleSection>
</template>

<script>
import ToggleSection from '@/components/fields/ToggleSection.vue'
import FieldGrid from '@/components/fields/FieldGrid.vue'

export default {
  name: 'VitrificationCryoTEM',
  components: { ToggleSection, FieldGrid },
  props: {
    dv: { type: Object, required: true },
    validationErrors: { type: Object, default: () => ({}) },
  },
}
</script>
